module.exports = __webpack_public_path__ + "static/media/04-02.6d903a02.mp3";